import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
function Vuotlink2() {
    const navigate = useNavigate();
    function okok() {
        navigate('/home/');
    };
    useEffect(() => {
        okok();
    }, []);
    return (
        <div>
            đợi
        </div>
    )
}
export default Vuotlink2;